import { render, staticRenderFns } from "./AudienceRule.vue?vue&type=template&id=6bc81460&scoped=true&"
import script from "./AudienceRule.vue?vue&type=script&lang=js&"
export * from "./AudienceRule.vue?vue&type=script&lang=js&"
import style0 from "./AudienceRule.vue?vue&type=style&index=0&id=6bc81460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc81460",
  null
  
)

export default component.exports